var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{staticClass:"bread",attrs:{"data":_vm.data}},[_c('el-breadcrumb',{attrs:{"separator":"/","open":""}},_vm._l((_vm.data),function(item,index){return _c('el-breadcrumb-item',{key:index,attrs:{"to":item.path}},[_vm._v(_vm._s(item.title))])}),1),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.data[_vm.data.length-1].title))])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49f55a78","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bread.vue
// module id = null
// module chunks = 